module.exports = __webpack_public_path__ + "media/images/webpage/pages/about/sp-section-3-cb71fdabaabb1fba045ae3c73204336e.webp";